exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wait {\n  width: 100%;\n  height: 70%;\n  padding-top: 30%;\n  text-align: center;\n  vertical-align: middle;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/knowledgecenter/ranking/ranking.component.styl
// module id = ../../../../../src/app/knowledgecenter/ranking/ranking.component.styl
// module chunks = main